import { createAction, props } from '@ngrx/store';

export const DecedentInfoUpdate = createAction('[Decedent Info] Update', props<{ payload: any }>());
export const OpenDecedentInfoReviewModal = createAction('[Decedent Info] Open Review Modal');
export const CloseDecedentInfoReviewModal = createAction('[Decedent Info] Close Review Modal');
export const DecedentIdExceededAttempts = createAction(
  '[Decedent Info] Decedent Id Exceeded Attempts',
);

export const IsDeathVerifiedUpdate = createAction(
  '[Decedent Info] Update isDeathVerified',
  props<{
    payload: {
      isDeathVerified: boolean;
    };
  }>(),
);

export const DecedentDODUpdate = createAction(
  '[Decedent Info] Update Date of Death',
  props<{ payload: { deathDate: string } }>(),
);

export const DecedentCityStateUpdate = createAction(
  '[Decedent Info] Update City State From Zip',
  props<{ payload: { addressLine1: string; city: string; state: string; zipCode: string } }>(),
);

export const resetDecedentInfo = createAction('[Decedent Info] Reset');

export const MarkAdvisedClientModalShown = createAction(
  '[Decedent Info] Mark Advised Client Modal Shown',
);
